export default "# Plays middle C\n\nsampleRate ← •SetSampleRate 8000\nNote ← 440 × 2 ⋆ 12 ÷˜ ⊢\n\n•math.Sin 2 × π × (Note ¯9) × ↕⌾(×⟜sampleRate) 2\n";